import { useEffect, useState } from 'react';
import { Col, Form, Input, Row, Select, message, Breadcrumb } from 'antd';
import Box from '../../components/Box';
import Button from '../../components/Button';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import giftCardApis from '../../services/giftCardApis';
import { SaveOutlined } from '@ant-design/icons';
import { PageStyled } from '../styles';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../store/loading/actions';
import dayjs from 'dayjs';
import SelectOrDatePicker from '../../components/Modal/SelectOrDatePicker';
import accountApis from '../../services/accountApis';
import { setShopState } from '../../store/shop/actions';
import BreadcrumbItemStyled from '../../components/FormItem/BreadcrumbItemStyled';
import UploadGiftCardImage from './components/UploadGiftCardImage';

export const SalonGiftCardCreatePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formCreate] = Form.useForm();
  const { id } = useParams();
  const startDate = dayjs();
  const [shopDate, setShopDate] = useState<any>(null);
  const [expireDate, setExpireDate] = useState<string>(dayjs().format('MM-DD-YYYY'));

  const handleChangeExpireDate = (value: any) => {
    if (!isNaN(value)) {
      value = startDate.add(value, 'day').format('MM-DD-YYYY');
    }
    setExpireDate(value);
  };

  const onSubmit = async (values: any) => {
    try {
      let totalExpireDate = 0;
      const currentDate = dayjs();
      const expireDateTem = dayjs(expireDate, 'MM-DD-YYYY');
      totalExpireDate = expireDateTem.diff(currentDate, 'day') + 1;
      if (totalExpireDate <= 0) {
        message.error({ content: 'Expires Date must to > Current Date', duration: 2 });
        return;
      }
      dispatch(setLoading(true));
      const response = await giftCardApis.CreateOrUpdateTemplate(
        null,
        true,
        totalExpireDate,
        values.amountOptions,
        values.urlImage,
        values.giftCardName
      );
      if (response.status === 200) {
        message.success({ content: 'Create Success' as string, duration: 2 });
        navigate(`/gift-card/${id}`);
      } else {
        message.error({ content: response.data.message as string, duration: 2 });
        dispatch(setLoading(false));
      }
    } catch (error: any) {
      dispatch(setLoading(false));
      message.error({ content: error.message as string, duration: 1 });
    }
  };

  useEffect(() => {
    const initData = async () => {
      if (id) {
        const resShopById = await accountApis.getShopById(id);
        if (resShopById.status === 200) {
          setShopDate(resShopById.data.data);
          dispatch(setShopState(resShopById.data.data));
        }
      }
    };
    initData();
  }, [dispatch, id]);

  return (
    <PageStyled>
      <Form form={formCreate} layout='vertical' onFinish={onSubmit}>
        <Box className='d-between'>
          <Breadcrumb style={{ marginBottom: '10px' }}>
            <BreadcrumbItemStyled>Salon {shopDate?.shopName}</BreadcrumbItemStyled>
            <BreadcrumbItemStyled>Create Gift Card</BreadcrumbItemStyled>
          </Breadcrumb>
          <Box display='flex' gap={1}>
            <Button onClick={() => navigate(`/gift-card/${id}`)}>Cancel</Button>
            <Button variant='PRIMARY' onClick={() => formCreate.submit()}>
              <SaveOutlined style={{ marginRight: '5px' }} />
              Save
            </Button>
          </Box>
        </Box>

        <ContentStyled>
          <Row>
            <Col
              xs={{ span: 24 }}
              md={{ span: 10 }}
              lg={{ span: 10 }}
              xl={{ span: 10 }}
              style={{ borderRight: '1px solid rgba(218, 218, 218, 1)' }}
            >
              <BoxTemplateStyled>
                <Form.Item
                  name='urlImage'
                  rules={[{ required: true, message: 'Thumbnail is required' }]}
                  style={{ marginBottom: 0 }}
                >
                  <UploadGiftCardImage />
                </Form.Item>
              </BoxTemplateStyled>
            </Col>

            <Col xs={{ span: 24 }} md={{ span: 14 }} lg={{ span: 14 }} xl={{ span: 14 }}>
              <Box style={{ background: 'white' }} p={1.5}>
                <Form.Item
                  name='giftCardName'
                  label='Gift Card Name'
                  rules={[
                    {
                      required: true,
                      message: 'Gift Card Name is required',
                    },
                  ]}
                >
                  <Input size='large' placeholder='Enter gift card name' />
                </Form.Item>

                <Box display='flex' gap={1}>
                  <div style={{ flex: 1 }}>
                    <Form.Item
                      name='amountOptions'
                      label='Amount'
                      rules={[
                        {
                          required: true,
                          message: 'Amount is required',
                        },
                      ]}
                    >
                      <Select mode='multiple' placeholder='Select' size='large'>
                        <Select.Option value={50}>$50.00</Select.Option>
                        <Select.Option value={100}>$100.00</Select.Option>
                        <Select.Option value={200}>$200.00</Select.Option>
                        <Select.Option value={500}>$500.00</Select.Option>
                        <Select.Option value={1000}>$1000.00</Select.Option>
                      </Select>
                    </Form.Item>
                  </div>
                  <div style={{ flex: 1 }}>
                    <Form.Item
                      name='expiresDate' // Tên của trường trong form
                      label='Expires Date'
                      rules={[
                        {
                          required: true,
                          message: 'Expires date is required',
                        },
                      ]}
                    >
                      <SelectOrDatePicker
                        disabled={false}
                        onChange={handleChangeExpireDate}
                        valueDf=''
                      />
                    </Form.Item>
                  </div>
                </Box>
              </Box>
            </Col>
          </Row>
        </ContentStyled>
      </Form>
    </PageStyled>
  );
};

const ContentStyled = styled.div`
  background: rgba(255, 255, 255, 1);
  margin-top: 2rem;
`;

const BoxTemplateStyled = styled(Box)`
  padding: 2rem;
`;
